module.exports = __webpack_public_path__ + "img/info_2.4ee414be.gif";